<template>
	<div>
		<div
			v-for="(notification, i) in computedNotifications"
			:key="i"
			class="p2 notification-item"
			:class="{ 'bb1 bc7': i < computedNotifications.length - 1 }"
		>
			<div class="flex">
				<div class="flex">
					<!-- is read -->
					<div>
						<div
							class="mr2 mt1 cu2 b1 bc7"
							:class="[
								{ 'bgError notification-unread-marker': !notification.isRead },
								{ 'bg4 notification-unread-marker': notification.isRead }
							]"
							@click="toggleNotificationIsRead(notification)"
						/>
					</div>
					<!-- content -->
					<div
						class="cu2"
						@click="onClickNotification(notification)"
						v-html="notification.content"
					></div>
				</div>
			</div>
		</div>
		<!-- If empty -->
		<div
			v-if="!computedNotifications.length"
			class="fs3 c6 flex xs-12 xs-center xs-middle p4"
		>
			{{ $t("errors.no_data") }}
		</div>
		<!-- page -->
		<div class="flex xs-12 xs-center xs-middle c6 p2">
			<div class="cu2 mr2 fw7" v-if="page > 1" @click="previousPage">
				&lt;
			</div>
			<div class="fs3 fw7">{{ page }}</div>
			<div class="cu2 ml2 fw7" v-if="page < numberOfPages" @click="nextPage">
				&gt;
			</div>
		</div>
	</div>
</template>

<script>
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	props: {
		listing: Object,
		itemsPerPage: Number,
		page: Number
	},

	computed: {
		computedNotifications() {
			if (!this?.listing?.list) return []
			return this.listing.list?.map(item => {
				return {
					id: item.id,
					isRead: item?.status === "READ",
					content: item?.internalMessage?.renderedHtml,
					data: item?.internalMessage?.dataJsonString
						? JSON.parse(item.internalMessage.dataJsonString)
						: {}
				}
			})
		},
		numberOfPages() {
			return this.listing.numberOfItems / this.itemsPerPage
		}
	},

	methods: {
		async toggleNotificationIsRead(notification) {
			const query = gql`
				mutation updateNotificationStatus(
					$notificationId: String!
					$status: String!
				) {
					updateNotificationStatus(
						notificationId: $notificationId
						status: $status
					) {
						errors
						status
					}
				}
			`
			const variables = {
				notificationId: notification.id,
				status: notification.isRead ? "NOT_READ" : "READ"
			}
			this.isLoading = true
			const res = await api({
				query,
				variables
			})
			this.isLoading = false
			// Check errors
			if (res?.data?.errors && res?.data?.errors?.length)
				this.$store.dispatch("showError", [res?.data.errors?.[0]?.message])

			this.$emit("refetch:list")
			this.$emit("refetch:unread")
		},

		async onClickNotification(notification) {
			const query = gql`
				mutation updateNotificationStatus(
					$notificationId: String!
					$status: String!
				) {
					updateNotificationStatus(
						notificationId: $notificationId
						status: $status
					) {
						errors
						status
					}
				}
			`
			const variables = {
				notificationId: notification.id,
				status: "READ"
			}
			this.isLoading = true
			const res = await api({ query, variables })
			this.isLoading = false
			// Check errors
			if (res?.data?.errors && res?.data?.errors?.length)
				this.$store.dispatch("showError", [res?.data.errors?.[0]])

			this.$emit("refetch:list")
			this.$emit("refetch:unread")

			/*
			 * Handle notification.data (route to policy...etc)
			 */
			if (notification.data?.policy)
				this.$router.push({
					name: "PolicyDetail",
					params: { id: notification.data.policy }
				})
			if (notification.data?.case)
				this.$router.push({
					name: "CaseManagementDetail",
					params: { id: notification.data.case }
				})
			if (notification.data?.user)
				this.$router.push({
					name: "UsersUpdate",
					params: { loginId: notification.data.user }
				})
			if (notification.data?.internal)
				this.$router.push({
					name: "InternalsDetail",
					params: { id: notification.data.internal }
				})
		},

		previousPage() {
			this.$emit("previous-page")
			this.$emit("refetch:list")
		},

		nextPage() {
			this.$emit("next-page")
			this.$emit("refetch:list")
		}
	}
}
</script>

<style scoped>
@import "../../../../assets/css/tokens.css";
.notification-item:hover {
	background-color: var(--color4);
}

.notification-unread-marker {
	height: 16px;
	width: 16px;
	border-radius: 8px;
}

.notification-unread-marker:hover {
	background: red;
	opacity: 50%;
}
</style>
